export default __webpack_public_path__ + "static/media/storageUnit1-afterD-480w.03883220.avif";